import {
  styled,
  Dialog,
  dialogClasses,
  DialogContent,
  DialogActions,
  Alert,
  AlertProps,
  alertClasses,
  Chip,
  ChipProps,
} from '@mui/material';
import { lighten } from '@mui/material/styles';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export const DialogImportOrdersFromCSVContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 600,
    width: '100%',
    minHeight: 402,
  },
});

export const DialogImportOrdersFromCSVLoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  flex: 1,
});

export const DialogImportOrdersFromCSVContentContainer = styled(DialogContent)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  }),
);

export const DialogImportOrdersFromCSVActions = styled(DialogActions)({
  justifyContent: 'space-between',
});

export const DialogImportOrdersFromCSVNewsAlertChip = styled(
  (props: ChipProps) => (
    <Chip variant="filled" color="primary" size="small" {...props} />
  ),
)(({ theme }) => ({
  ...theme.typography.caption,
  fontWeight: theme.typography.fontWeightBold,
  borderRadius: 20,
}));

export const DialogImportOrdersFromCSVNewsAlert = styled(
  (props: AlertProps) => (
    <Alert
      variant="standard"
      icon={<AutoAwesomeIcon fontSize="inherit" />}
      {...props}
    >
      <DialogImportOrdersFromCSVNewsAlertChip label="Nuevo" />

      {props.children}
    </Alert>
  ),
)(({ theme }) => ({
  ...theme.typography.body2,
  fontWeight: theme.typography.fontWeightMedium,
  border: `1px solid ${theme.palette.primary.light}`,
  backgroundColor: lighten(theme.palette.primary.light, 0.9),
  color: theme.palette.primary.dark,

  [`& .${alertClasses.icon}`]: {
    color: theme.palette.primary.light,
  },

  [`& .${alertClasses.message}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
  },
}));
